import React, { Fragment, useState, useEffect, useRef} from "react";
import { Row, Col, Container, Card, Collapse } from "reactstrap";
import "../../style/styleeconfirm.css";


export default function PopUpSuccess(props) {
  // const {toggle}=props.toggle;
  const [open, setOpen] = useState('false');

  useEffect(() => {
    props.toggle ==true ? setOpen('true') : setOpen('false')
  }, [props.toggle]);

  return (
    <div className="popup-overlayn">
      <div className="popup-contentn">
<br/>
<div>
  <i class="fa fa-check" style={{fontSize:"2.5em"}}></i><br/>
  </div>
<br/>
<h5>Deleted Successfully</h5>
{/* <h9>You will not be able to recover this..</h9> */}
<br/>
<div>
<button className="btn-admin-settings btn btn-" onClick={props.hadleSuccessPop}>Ok</button>&nbsp;&nbsp;

</div>
<br/>
      </div>
    </div>

  );
}
